module.exports = __webpack_public_path__ + "img/engineer-logo-3.c9c53138.png";